import { useState, useEffect } from "react";
import { Row, Col } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import { ProductServices } from "../../../../services";
import { ButtonCommon, DataTableProducts } from "../../../common";

const ListProducts = (props: any) => {
    const [isLoading, setIsLoading] = useState(false);
    const [products, setProducts] = useState([{}]);
    const [productSelection, setProductsSelection] = useState([]);

    const navigate = useNavigate();
    const params = useParams();

    // console.log('LIST PARAMS', params);

    async function getProductos() {

        try {
            setIsLoading(true);

            const getProductResponse = await ProductServices.GetProducts();

            if ((getProductResponse) && (getProductResponse.Status === 200)) {
                setProducts(getProductResponse.Content);
            } else {
                setProducts([]);
            }

            setIsLoading(false);

        } catch (error) {
            console.log(error);

            setIsLoading(false);
        }
    }

    useEffect(() => {

        getProductos();
        
        if (props.onListProductChange) props.onListProductChange(products.length);

    }, [products.length, props.onListProductChange]);

    const onSuscribeProductsSelectionChange = (value: any) => {

        setProductsSelection(value);

    }

    const onSuscribeDelete = (data: any) => {
        try {
            // if ((productSelection) && (productSelection.length > 0)) {
            //     console.log('Click Borrar', productSelection);
            // }
            // else {
                console.log('Click Borrar', data);
            // }

        } catch (error) {
            console.log(error);
        }
    }

    const onSuscribeDeleteGroup = (data: any) => {
        try {
            // if ((productSelection) && (productSelection.length > 0)) {
            //     console.log('Click Borrar', productSelection);
            // }
            // else {
                console.log('Click Borrar List', data);
            // }

        } catch (error) {
            console.log(error);
        }
    }

    const onSuscribeEdit = (data: any) => {
        try {
            // if ((productSelection) && (productSelection.length > 0)) {
            //     console.log('Click Editar', productSelection);
            // }
            // else {
                console.log('Click Editar', data);
            // }

        } catch (error) {
            console.log(error);
        }
    }

    const onSuscribeAddSizeGuide = (data: any) => {
        console.log('Click Asociar Guía', data);
    }

    const onSuscribeDownloadData = (data: any) => {
        console.log('Click Download', data);
    }

    const onClickGoBack = () => {
        console.log('GO BACK');

        navigate(-1);
    }

    return (
        <>
            <Row className="justify-content-center">
                <DataTableProducts products={products}
                    isLoading={isLoading}
                    scrollHeight={"flex"} 
                    handlerSelectionRow={onSuscribeProductsSelectionChange}
                    //handlerDelete={onSuscribeDelete}
                    //handlerEdit={onSuscribeEdit}
                    //handlerDeleteGroup={onSuscribeDeleteGroup}
                    //handlerAddSizeGuideGroup={onSuscribeAddSizeGuide}
                    handlerDownload={onSuscribeDownloadData}
                    />
            </Row>
            <Row className="mt-3">
                <Col xs={1} className="ps-0">
                    <ButtonCommon label="Volver"
                        isOutline={true} 
                        eventClick={() => onClickGoBack()} />
                </Col>
                <Col xs={1} className={((productSelection.length === 0) ? 'd-none' : 'd-block') + ' ps-0'}>
                    <ButtonCommon label="Guardar"
                        isOutline={false} 
                        disabled={((productSelection.length === 0) ? true : false)}
                        eventClick={() => onClickGoBack()} />
                </Col>
            </Row>
            <br />
        </>
    );
}

export default ListProducts;